import { Dialog, DialogContent, Menu, MenuItem } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { AutoTransactionForm } from "../../pages/Settings/AutoTransactionForm";
import type { AppliedRulesMenuController } from "./useAppliedRulesMenu";

export type AppliedRulesMenuProps = {
  controller: AppliedRulesMenuController;
};

export const AppliedRulesMenu = ({ controller }: AppliedRulesMenuProps) => {
  const {
    editingRuleId,
    anchorEl,
    activeTransaction,
    closeMenu,
    openRule,
    closeEditing,
    handleRuleUpdated,
  } = controller;

  return (
    <>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        {activeTransaction?.appliedRules.map((rule) => (
          <MenuItem
            key={rule.id}
            onClick={() => openRule(rule)}
            // A deleted invoice leaves nothing to open; the entry stays so
            // the user sees what was applied.
            disabled={!!rule.invoice && rule.broken}
            sx={rule.broken ? { color: "error.main" } : undefined}
          >
            {rule.broken && (
              <WarningAmberIcon fontSize="small" sx={{ mr: 1 }} />
            )}
            {rule.name}
          </MenuItem>
        ))}
      </Menu>
      <Dialog
        open={!!editingRuleId}
        onClose={closeEditing}
        maxWidth="md"
        fullWidth
      >
        <DialogContent sx={{ p: 0 }}>
          {editingRuleId && (
            <AutoTransactionForm
              ruleId={editingRuleId}
              onClose={closeEditing}
              onSuccess={handleRuleUpdated}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
